import { InjectionToken } from '@angular/core';
import { HttpErrorHandlerFn } from '../errors/handlers/http-error-handler-fn';

export const HTTP_ERROR_HANDLERS = new InjectionToken<HttpErrorHandlerFn[]>(
  'HTTP_ERROR_HANDLERS',
);
